(function () {
var C = window.SFG || {};
var courses = (C.courses || []).filter(function (c) { return c.tiers && c.tiers.length; });
if (!courses.length) return;
courses.forEach(function (c) { c.tiers.sort(function (a, b) { return a.min - b.min; }); });
var $ = function (id) { return document.getElementById(id); };
var money = function (n) {
return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
};
var track = function (ev, data) {
window.dataLayer = window.dataLayer || [];
window.dataLayer.push(Object.assign({ event: ev }, data || {}));
};
function tierFor(c, q) {
for (var i = c.tiers.length - 1; i >= 0; i--) if (q >= c.tiers[i].min) return { t: c.tiers[i], i: i };
return null;
}
function label(t) { return t.max ? t.min + '–' + t.max : t.min + '+'; }
var qty = {};
courses.forEach(function (c, i) { qty[c.key] = i === 0 ? 10 : 0; });
/* Add-on rule: once any course has a full group (6+ seats), other courses can be added at 1+ seats
   at that course's first group price, so a team can buy everything it needs in one checkout. */
function anchored(exceptKey) {
return courses.some(function (c) { return c.key !== exceptKey && (qty[c.key] || 0) >= c.tiers[0].min; });
}
var lines = [];
function render() {
var box = $('sfg-lines'), main = '', more = '', moreNames = [];
courses.forEach(function (c) {
var row = '<div class="sfg-row" data-row="' + c.key + '">' +
'<div class="sfg-row__top"><div class="sfg-row__name"><span>' + c.name + '</span><small>' + (c.desc ? c.desc + ' ' : '') + 'From ' + money(c.tiers[c.tiers.length - 1].price) + '/seat.</small></div>' +
'<div class="sfg-qty"><button type="button" data-step="-1" data-key="' + c.key + '" aria-label="Fewer ' + c.name + ' seats">&minus;</button>' +
'<input type="number" inputmode="numeric" min="0" max="2000" step="1" data-key="' + c.key + '" value="' + (qty[c.key] || '') + '" placeholder="0" aria-label="' + c.name + ' seats">' +
'<button type="button" data-step="1" data-key="' + c.key + '" aria-label="More ' + c.name + ' seats">+</button></div></div>' +
'<div data-out="' + c.key + '"></div></div>';
if ((c.group || 'AHA courses') === 'AHA courses') { main += row; } else { more += row; moreNames.push(c.name.replace(/ Level [0-9]| Pro Package/, '')); }
});
var uniq = moreNames.filter(function (n, i) { return moreNames.indexOf(n) === i; });
box.innerHTML = main + (more ? '<button type="button" class="sfg-more" id="sfg-more" aria-expanded="false" aria-controls="sfg-more-list">+ Add ' + uniq.join(' or ') + ' courses</button><div id="sfg-more-list" class="sfg-more-list" hidden>' + more + '</div>' : '');
var mb = $('sfg-more'); if (mb) mb.setAttribute('data-label', mb.textContent);
update();
}
function update() {
var seats = 0, total = 0, save = 0, bad = false;
lines = [];
courses.forEach(function (c) {
var q = qty[c.key] || 0, out = document.querySelector('[data-out="' + c.key + '"]'), html = '';
var row = document.querySelector('[data-row="' + c.key + '"]');
if (row) row.classList.toggle('is-on', q > 0);
if (q > 0 && q < c.tiers[0].min && anchored(c.key)) {
var at = c.tiers[0], aline = at.price * q;
lines.push({ variant: at.variantId, qty: q, name: c.name });
seats += q; total += aline; save += (c.regular - at.price) * q;
html = '<div class="sfg-line__price"><div class="sfg-line__per"><strong>' + money(at.price) + '</strong> per seat <s>' + money(c.regular) + '</s>' +
'<span class="sfg-line__tier">Add-on at group price</span></div><div class="sfg-line__total">' + money(aline) + '</div></div>';
} else if (q > 0 && q < c.tiers[0].min) {
bad = true;
html = '<div class="sfg-err">Group pricing starts at ' + c.tiers[0].min + ' seats. Once one course has ' + c.tiers[0].min + '+, you can add as few as 1 seat of the others.</div>';
} else if (q > 0) {
var r = tierFor(c, q), t = r.t, line = t.price * q;
lines.push({ variant: t.variantId, qty: q, name: c.name });
seats += q; total += line; save += (c.regular - t.price) * q;
html = '<div class="sfg-line__price"><div class="sfg-line__per"><strong>' + money(t.price) + '</strong> per seat <s>' + money(c.regular) + '</s>' +
'<span class="sfg-line__tier">' + label(t) + ' seat price</span></div><div class="sfg-line__total">' + money(line) + '</div></div>';
var nx = c.tiers[r.i + 1];
if (nx) {
var need = nx.min - q;
if (need <= Math.max(3, Math.ceil(nx.min * 0.2))) {
html += '<div class="sfg-nudge">Add ' + need + ' more and pay ' + money(nx.price) + ' per seat. <button type="button" data-bump="' + c.key + '" data-to="' + nx.min + '">Make it ' + nx.min + '</button></div>';
}
}
}
if (out) out.innerHTML = html;
});
$('sfg-seats').textContent = seats;
$('sfg-total').textContent = money(total);
$('sfg-save').textContent = money(save);
$('sfg-checkout').disabled = !(lines.length && !bad && $('sfg-terms').checked);
}
var root = $('sfg');
root.addEventListener('input', function (e) {
var k = e.target.getAttribute('data-key'); if (!k || e.target.tagName !== 'INPUT') return;
qty[k] = Math.max(0, parseInt(e.target.value, 10) || 0);
update();
});
root.addEventListener('change', function (e) {
if (e.target.id === 'sfg-terms') update();
});
root.addEventListener('click', function (e) {
var t = e.target.closest ? e.target.closest('button') || e.target : e.target;
if (t.hasAttribute('data-step')) {
var k = t.getAttribute('data-key'), c = courses.filter(function (x) { return x.key === k; })[0];
var cur = qty[k] || 0, d = +t.getAttribute('data-step'), addon = anchored(k), nv;
if (d > 0) nv = cur === 0 ? (addon ? 1 : c.tiers[0].min) : cur + 1;
else nv = addon ? Math.max(0, cur - 1) : (cur <= c.tiers[0].min ? 0 : cur - 1);
qty[k] = nv; var inp = root.querySelector('input[data-key="' + k + '"]'); if (inp) inp.value = nv || '';
update();
}
if (t.hasAttribute('data-bump')) {
var bk = t.getAttribute('data-bump'); qty[bk] = +t.getAttribute('data-to');
var bi = root.querySelector('input[data-key="' + bk + '"]'); if (bi) bi.value = qty[bk];
update();
}
if (t.id === 'sfg-more') { var ml = $('sfg-more-list'), open = ml.hasAttribute('hidden'); if (open) { ml.removeAttribute('hidden'); } else { ml.setAttribute('hidden', ''); } t.setAttribute('aria-expanded', open ? 'true' : 'false'); t.textContent = open ? '− Hide more courses' : t.getAttribute('data-label'); }
if (t.hasAttribute('data-sfg-build')) { $('sfg-builder').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
if (t.hasAttribute('data-sfg-open')) openModal();
if (t.hasAttribute('data-sfg-close') || t.id === 'sfg-modal') closeModal();
});
$('sfg-checkout').addEventListener('click', function () {
var btn = this, msg = $('sfg-msg');
var co = $('sfg-company'), coName = co ? co.value.trim() : '';
if (co && !coName) { co.classList.add('is-err'); msg.textContent = 'Please add your company or facility name.'; co.focus(); return; }
var items = lines.map(function (l) {
return { id: l.variant, quantity: l.qty, properties: { _sale_channel: 'B2B group' } };
});
track('group_checkout_start', {
seats: items.reduce(function (a, b) { return a + b.quantity; }, 0),
value: parseFloat($('sfg-total').textContent.replace(/[$,]/g, '')), currency: 'USD'
});
if (C.mode === 'preview') {
msg.textContent = 'Preview only: this would add ' + items.length + ' line(s) to the cart and go to checkout.';
return;
}
btn.disabled = true; msg.textContent = 'Getting your checkout ready…';
var post = function (url, body) {
return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
.then(function (r) { if (!r.ok) throw r; return r.json(); });
};
post('/cart/clear.js', {})
.then(function () { return post('/cart/add.js', { items: items }); })
.then(function () {
return post('/cart/update.js', { attributes: {
'Group terms accepted': 'Yes',
'Group terms version': C.termsVersion || '',
'Group terms accepted at': new Date().toISOString(),
'Company': coName,
'Group seat total': String(lines.reduce(function (a, l) { return a + l.qty; }, 0)),
'Group order items': lines.map(function (l) { return l.qty + ' ' + l.name; }).join(', ')
} });
})
.then(function () { window.location.href = '/checkout'; })
.catch(function () { btn.disabled = false; msg.textContent = 'Something went wrong. Please try again or talk to group sales.'; });
});
/* lead modal */
var modal = $('sfg-modal'), lastFocus = null, hsLoaded = false;
function openModal() {
lastFocus = document.activeElement; modal.classList.add('is-open');
loadHubSpot();
setTimeout(function () { var f = modal.querySelector('input,select,button'); if (f) f.focus(); }, 50);
track('group_lead_open');
}
function closeModal() { modal.classList.remove('is-open'); if (lastFocus) lastFocus.focus(); }
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });
function thanks() {
$('sfg-formwrap').style.display = 'none'; $('sfg-thanks').classList.add('is-on');
track('group_lead_submit');
}
function loadHubSpot() {
var hs = C.hubspot || {};
if (hsLoaded || !hs.portalId || !hs.formId) return;
hsLoaded = true;
var s = document.createElement('script');
s.src = 'https://js.hsforms.net/forms/embed/v2.js'; s.charset = 'utf-8';
s.onload = function () {
$('sfg-hs-form').innerHTML = '';
window.hbspt.forms.create({
region: hs.region || 'na1', portalId: hs.portalId, formId: hs.formId, target: '#sfg-hs-form',
onFormSubmitted: thanks
});
};
document.head.appendChild(s);
}
var mock = $('sfg-mockform');
if (mock) mock.addEventListener('submit', function (e) { e.preventDefault(); if (mock.reportValidity()) thanks(); });
var sticky = $('sfg-sticky');
if (sticky && 'IntersectionObserver' in window) {
var hero = $('sfg-builder'), cta = $('sfg-cta');
var vis = { b: true, c: false };
var io = new IntersectionObserver(function (es) {
es.forEach(function (en) { vis[en.target === hero ? 'b' : 'c'] = en.isIntersecting; });
sticky.classList.toggle('is-on', !vis.b && !vis.c);
});
io.observe(hero); if (cta) io.observe(cta);
}
var fc = courses.filter(function (c) { return /bls/i.test(c.key + c.name); })[0] || courses[0];
if ($('sfg-from')) { var lt = fc.tiers[fc.tiers.length - 1]; $('sfg-from').textContent = money(lt.price); $('sfg-from-l').textContent = 'per ' + fc.name + ' seat at ' + lt.min + '+'; }
/* company field: required before checkout, sent to the order as a cart attribute */
function addCompany() {
if ($('sfg-company')) return;
var terms = $('sfg-terms'), lab = terms && terms.closest ? terms.closest('label') : null;
if (!lab || !lab.parentNode) return;
var st = document.createElement('style');
st.textContent = '.sfg-co{margin:14px 0 10px}.sfg-co label{display:block!important;font-weight:600;margin-bottom:6px}.sfg-co label span{display:inline!important;margin-left:2px}.sfg-co label span{color:#C8102E}.sfg-co input{width:100%;box-sizing:border-box;padding:12px 14px;border:1px solid #bbb;border-radius:8px;font:inherit;background:#fff}.sfg-co input:focus{border-color:#565352;outline:none}.sfg-co input.is-err{border-color:#C8102E;box-shadow:0 0 0 2px rgba(200,16,46,.15)}';
document.head.appendChild(st);
var w = document.createElement('div'); w.className = 'sfg-co';
w.innerHTML = '<label for="sfg-company">Company or facility name <span aria-hidden="true">*</span></label><input id="sfg-company" name="company" type="text" required maxlength="120" autocomplete="organization" placeholder="e.g. Sunrise Dental">';
lab.parentNode.insertBefore(w, lab);
w.querySelector('input').addEventListener('input', function () { this.classList.remove('is-err'); var m = $('sfg-msg'); if (m && /company/.test(m.textContent)) m.textContent = ''; });
}
addCompany();
render();
})();
